// extracted by mini-css-extract-plugin
export default {"unspacedLabel":"LanguageSelect_unspacedLabel__e-+eL","spacedLabel":"LanguageSelect_spacedLabel__4qxgp"};